if (!window.Eurus.loadedScript.has('product-media.js')) {
  window.Eurus.loadedScript.add('product-media.js');

  const registerXProductMedia = () => {
    Alpine.data('xProductMedia', (settings) => ({
        thumbnailOnMouseDown: false,
        thumbnailOfset: 0,
        thumbnailScrollOfset: 0,
        thumbnailGrabbingClass: '',
        zoomIsOpen: false,
        zoomImageSrc: '',
        zoomImageAlt: '',
        hiccZoomMedia: settings.hicc_zoom_media || [],
        zoomActiveIndex: 0,
        productMediaIsOpen: '',
        videoExternalListened: false,
        xPosition: 0,
        yPosition: 0,
        imageWidth: 0,
        imageHeight: 0,
        startZoom(event) {
          const elem = event.currentTarget;
          const size = elem.getBoundingClientRect();
          this.xOffset = size.left;
          this.yOffset = size.top;
          this.imageWidth = size.width;
          this.imageHeight = size.height;
        },
        updatePosition(event) {
          if (this.imageWidth && this.imageHeight) {
            this.xPosition = ((event.clientX - this.xOffset) / this.imageWidth) * 100;
            this.yPosition = ((event.clientY - this.yOffset)  / this.imageHeight) * 100;
          }
        },
        thumbnailHandleMouseDown(e) {
          this.thumbnailOnMouseDown = true;
          this.thumbnailGrabbingClass = 'cursor-grabbing';
          if (settings.thumbnail_direction == 'horizontal') {
            this.thumbnailOfset = e.pageX - this.$refs.thumbnail.offsetLeft;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollLeft;
          } else {
            this.thumbnailOfset = e.pageY - this.$refs.thumbnail.offsetTop;
            this.thumbnailScrollOfset = this.$refs.thumbnail.scrollTop;
          }
        },
        thumbnailHandleMouseMove(e) {
          if(!this.thumbnailOnMouseDown) return;
          e.preventDefault();
          if (settings.thumbnail_direction == 'horizontal') {
            const x = e.pageX - this.$refs.thumbnail.offsetLeft;
            const walk = (x - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollLeft = this.thumbnailScrollOfset - walk;
          }
          else {
            const y = e.pageY - this.$refs.thumbnail.offsetTop;
            const walk = (y - this.thumbnailOfset) * 2; 
            this.$refs.thumbnail.scrollTop = this.thumbnailScrollOfset - walk;
          }
        },
        thumbnailHandleMouseLeave() {
          this._thumbnailRemoveGrabing();
        },
        thumbnailHandleMouseUp() {
          this._thumbnailRemoveGrabing();
        },
        _thumbnailRemoveGrabing() {
          this.thumbnailOnMouseDown = false;
          this.thumbnailGrabbingClass = 'md:cursor-grab';
        },
        zoomOpenSingle(src, alt) {
          this.zoomImageSrc = src;
          this.zoomImageAlt = alt || '';
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
        },
        zoomOpenHicc(position) {
          const idx = this.hiccZoomMedia.findIndex((item) => String(item.position) === String(position));
          this.zoomActiveIndex = idx >= 0 ? idx : 0;
          Alpine.store('xPopup').open = true;
          this.zoomIsOpen = true;
          this.$nextTick(() => {
            const mainEl = document.getElementById(`HiccLightboxMain-${settings.section_id}`);
            if (mainEl) this._hiccFitViewport(mainEl, this.zoomActiveIndex);
            this._hiccInitSwiper(() => this._hiccGoToSlide(this.zoomActiveIndex));
          });
        },
        hiccZoomPrev() {
          if (!this.zoomIsOpen || !this._hiccMainSwiper || this.zoomActiveIndex <= 0) return;
          this._hiccMainSwiper.slidePrev();
        },
        hiccZoomNext() {
          if (!this.zoomIsOpen || !this._hiccMainSwiper) return;
          if (this.zoomActiveIndex >= this.hiccZoomMedia.length - 1) return;
          this._hiccMainSwiper.slideNext();
        },
        _hiccWaitSwiper(cb, retries = 40) {
          if (typeof window.Swiper !== 'undefined') {
            cb();
            return;
          }
          if (retries <= 0) return;
          setTimeout(() => this._hiccWaitSwiper(cb, retries - 1), 50);
        },
        _hiccDestroySwiper() {
          if (this._hiccMainSwiper) {
            this._hiccMainSwiper.destroy(true, true);
            this._hiccMainSwiper = null;
          }
          if (this._hiccThumbsSwiper) {
            this._hiccThumbsSwiper.destroy(true, true);
            this._hiccThumbsSwiper = null;
          }
          const viewport = document
            .getElementById(`HiccLightboxMain-${settings.section_id}`)
            ?.closest('.hicc-lightbox__main-viewport');
          if (viewport) {
            viewport.style.width = '';
            viewport.style.height = '';
            viewport.classList.remove('is-sized');
          }
        },
        _hiccInitSwiper(onReady) {
          const sectionId = settings.section_id;
          const mainEl = document.getElementById(`HiccLightboxMain-${sectionId}`);
          if (!mainEl) return;

          if (this._hiccMainSwiper) {
            onReady?.();
            return;
          }

          this._hiccWaitSwiper(() => {
            if (this._hiccMainSwiper) {
              onReady?.();
              return;
            }

            const thumbsEl = document.getElementById(`HiccLightboxThumbs-${sectionId}`);
            const count = this.hiccZoomMedia.length;

            if (thumbsEl && count > 1) {
              this._hiccThumbsSwiper = new window.Swiper(thumbsEl, {
                spaceBetween: 8,
                slidesPerView: 5,
                freeMode: true,
                watchSlidesProgress: true,
                slideToClickedSlide: true,
                breakpoints: {
                  768: { spaceBetween: 10, slidesPerView: 7 },
                },
              });
            }

            const config = {
              slidesPerView: 1,
              spaceBetween: 10,
              speed: 300,
              observer: true,
              observeParents: true,
              keyboard: { enabled: true, onlyInViewport: false },
              on: {
                slideChange: (swiper) => {
                  this.zoomActiveIndex = swiper.activeIndex;
                },
                slideChangeTransitionEnd: (swiper) => {
                  this._hiccFitViewport(mainEl, swiper.activeIndex);
                  swiper.update();
                },
              },
            };

            if (count > 1) {
              if (this._hiccThumbsSwiper) {
                config.thumbs = { swiper: this._hiccThumbsSwiper };
              }
            }

            this._hiccMainSwiper = new window.Swiper(mainEl, config);
            this._hiccRefreshMainLayout(mainEl, onReady);
          });
        },
        _hiccSlideDimensions(index, img) {
          const meta = this.hiccZoomMedia[index];
          const nw = img?.naturalWidth || meta?.width;
          const nh = img?.naturalHeight || meta?.height;
          return { nw, nh };
        },
        _hiccGetSlideDisplaySize(nw, nh) {
          if (!nw || !nh) return null;
          const isMobile = window.innerWidth < 768;
          const maxW = Math.min(window.innerWidth * 0.96, 1200);
          const maxH = isMobile
            ? Math.max(200, window.innerHeight - 160)
            : Math.min(window.innerHeight * 0.85, 920);
          const ratio = nw / nh;
          let w = maxW;
          let h = Math.round(w / ratio);
          if (h > maxH) h = maxH;
          return { w, h };
        },
        _hiccFitViewport(mainEl, slideIndex) {
          const viewport = mainEl?.closest('.hicc-lightbox__main-viewport');
          if (!viewport || !mainEl) return;
          const index = slideIndex ?? this._hiccMainSwiper?.activeIndex ?? this.zoomActiveIndex ?? 0;
          const slide = mainEl.querySelectorAll('.swiper-slide')[index];
          const img = slide?.querySelector('.hicc-lightbox__slide-img');
          const { nw, nh } = this._hiccSlideDimensions(index, img);
          const size = this._hiccGetSlideDisplaySize(nw, nh);
          if (!size) return;
          if (viewport.offsetWidth === size.w && viewport.offsetHeight === size.h) {
            viewport.classList.add('is-sized');
            return;
          }
          viewport.style.width = `${size.w}px`;
          viewport.style.height = `${size.h}px`;
          viewport.classList.add('is-sized');
        },
        _hiccRefreshMainLayout(mainEl, callback) {
          const run = () => {
            this._hiccFitViewport(mainEl);
            this._hiccMainSwiper?.update();
            this._hiccThumbsSwiper?.update();
            callback?.();
          };
          if (!mainEl) {
            callback?.();
            return;
          }
          const imgs = [...mainEl.querySelectorAll('.hicc-lightbox__slide-img')];
          const waiting = imgs.filter((img) => !img.complete || !img.naturalWidth);
          if (!waiting.length) {
            run();
            return;
          }
          let left = waiting.length;
          const check = () => {
            left -= 1;
            if (left <= 0) run();
          };
          waiting.forEach((img) => {
            img.addEventListener('load', check, { once: true });
            img.addEventListener('error', check, { once: true });
          });
        },
        _hiccGoToSlide(index) {
          if (this._hiccMainSwiper && !this._hiccMainSwiper.destroyed) {
            const mainEl = document.getElementById(`HiccLightboxMain-${settings.section_id}`);
            this._hiccRefreshMainLayout(mainEl, () => {
              this._hiccMainSwiper.slideTo(index, 0);
              this.zoomActiveIndex = index;
            });
          }
        },
        zoomOpen(position, isSplide) {
          this.zoomIsOpen = true;
          Alpine.store('xPopup').open = true;
          setTimeout(() => {
            if (isSplide) {
              const splideEl = document.getElementById(`media-gallery-${settings.section_id}`)
              if (splideEl && splideEl.splide) {
                let nextSlideIndex = 0;
                const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                childrenArray.map((item, index) => {
                  if (item.getAttribute('x-slide-index') == position) {
                    nextSlideIndex = index
                  }
                })
                splideEl.splide.go(nextSlideIndex);
              }
              document.addEventListener(`eurus:zoom-image-ready:${settings.section_id}`, () => {
                if (splideEl && splideEl.splide) {
                  let nextSlideIndex = 0;
                  const childrenArray = Array.from(splideEl.querySelector('.splide__list').children)
                  childrenArray.map((item, index) => {
                    if (item.getAttribute('x-slide-index') == position) {
                      nextSlideIndex = index
                    }
                  })
                  splideEl.splide.go(nextSlideIndex);
                }
              });
            }
            else {
              document.getElementById(position + '-image-zoom-' + settings.section_id).scrollIntoView({ behavior: 'smooth', block: 'start' })
            }
          }, 200);
          Alpine.store('xModal').activeElement = 'product-image-' + settings.section_id + '-' + position;
        },
        zoomClose() {
          this.zoomIsOpen = false;
          this.zoomImageSrc = '';
          this.zoomImageAlt = '';
          this._hiccDestroySwiper();
          Alpine.store('xPopup').close();
        },
        
        videoHandleIntersect() {
          if (settings.video_autoplay) {
            Alpine.store('xVideo').play(this.$el);
          }
        },
        productModelInit() {
          window.Shopify.loadFeatures([
            {
              name: 'shopify-xr',
              version: '1.0',
              onLoad: this._productModelSetupShopifyXR,
            },
          ]);
        },
        _productModelSetupShopifyXR() {
          const setup = () => {
            document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
              window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
              modelJSON.remove();
            });
            window.ShopifyXR.setupXRElements();
          }
  
          if (!window.ShopifyXR) {
            document.addEventListener('shopify_xr_initialized', () => {
              setup();
            });
            return;
          }
      
          setup();
        },
        productModelLoadMedia() {
          let container = this.$el.parentNode;
          const content = document.createElement('div');
          content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
  
          this.$el.classList.add('hidden');
          container.appendChild(content.querySelector('model-viewer'));
  
          this._productModelLoadViewerUI();
        },
        productModelPauseViewer() {
          if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause();
        },
        _productModelLoadViewerUI() {
          window.Shopify.loadFeatures([
            {
              name: 'model-viewer-ui',
              version: '1.0',
              onLoad: this._productModelSetupViewerUI.bind(this),
            },
          ]);
        },
        _productModelSetupViewerUI(errors) {
          if (errors) return;
  
          this.$el.parentNode.modelViewerUI
            = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); 
        }
      }));
  };

  document.addEventListener('alpine:init', registerXProductMedia);
  if (window.Alpine) {
    registerXProductMedia();
  }
}